import * as THREE from "three";

function isVector3(value: unknown): value is THREE.Vector3 {
	return value instanceof THREE.Vector3;
}

export { isVector3 };
